<div class="content-print" *ngIf="data.print === 'IMPRIMIR'">
    <div class="close" style="text-align: right; width: 100%; cursor: pointer;" *ngIf="!print">
        <h4 (click)="onNoClick()"><mat-icon>close</mat-icon></h4>
    </div>
    <div class="actions-dialog" style="margin-bottom: 3px;" *ngIf="print">
      <mat-radio-group  [(ngModel)]="position" style="margin-left: 35px;">
        <mat-radio-button color="warn" class="btn-cancelar" style="font-weight: bold; font-size: 16px;" value="horizontal"  (click)="position = 'horizontal'">HORIZONTAL</mat-radio-button>
        <mat-radio-button color="warn" class="btn-cancelar" style="font-weight: bold; font-size: 16px;" value="vertical" (click)="position = 'vertical'">VERTICAL</mat-radio-button>
      </mat-radio-group>
    </div>

  <!-- HORIZONTAL PERSONAL -->
  <div class="horizontal" *ngIf="position === 'horizontal' && itemSelected && !isVehicle">
  <div class="first">
          <div class="title">{{itemSelected.EmployerName}}</div>
          <div class="content-horizontal">
              <img src="{{s3Bucket+itemSelected.Photo}}" alt="">
              <div class="information">
                  <div class="field">Nombre:</div>
                  <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Name}}</div>
                  <div class="field">Apellido:</div>
                  <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.LastName}}</div>
                  <div class="field">Cargo:</div>
                  <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Position}}</div>
                  <div class="field" style="text-align: center; font-weight: 700;">{{'ID'}}: {{itemSelected.DocumentNumber}}</div>
              </div>
          </div>
      </div>
      <div class="second">
          <div class="terms">
              Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
          </div>
          <div class="content-horizontal">
              <div class="information">
                  <div class="information-data">
                      <div class="filed">EPS: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameEPS}}</label></div>
                      <div class="filed">ARL: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameARL}}</label></div>
                      <div class="filed">RH: <label style="text-align: center; font-weight: 700;">{{itemSelected.RH}}</label></div>
                  </div>
              </div>
              <div class="content-qr">
                  <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
                  <ngx-qrcode
                      *ngIf="valueQR !== ''"
                      [elementType]="elementType"
                      [errorCorrectionLevel]="correctionLevel"
                      [value]="valueQR"
                      alt="Demo QR Code"
                      cssClass="qr"
                      [width]="135">
                  </ngx-qrcode>
              </div>
          </div>
          <div class="information-autoriza">
            <hr>
            <div class="Aut">Autoriza: </div>
          </div>
      </div>
  </div>

  <!-- HORIZONTAL VEHICLE IMPRIMIR -->
  <div class="horizontal" *ngIf="position === 'horizontal' && itemSelected && isVehicle">
    <div class="first">
      <div class="title">{{itemSelected.EmployerName}}</div>
      <div class="content-horizontal">
        <img src="{{getImgVehicle(itemSelected.Photo)}}" alt="">
        <div class="information-vehicle-horizontal">
          <div class="field-vehicle-horizontal doc-type">
            <span class="owner-label-horizontal">Tipo de documento:</span>
            <span class="doc-type-value-row" [class.stacked]="itemSelected?.DocumentType === 'REGISTRO_MAQUINARIA'">
              <span class="owner-value-horizontal">{{ getDocumentTypeLabel(itemSelected?.DocumentType) }}</span>
              <span class="owner-value-horizontal">{{ itemSelected.Name }}</span>
            </span>
          </div>
          <div class="field-vehicle-horizontal" *ngIf="itemSelected?.DocumentType !== 'REGISTRO_MAQUINARIA'">{{ getVehicleType(itemSelected?.VehicleTypeId) }}</div>
          <div class="field-vehicle-horizontal owner">
            <span class="owner-label-horizontal">Propietario:</span>
            <span class="owner-value-horizontal">{{ (itemSelected?.OwnerName || '—') | uppercase }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="terms">
        Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
      </div>
      <div class="content-horizontal">
        <div class="information">
          <div class="information-data">

          </div>
        </div>
        <div class="content-qr">
          <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
          <ngx-qrcode
            *ngIf="valueQR !== ''"
            [elementType]="elementType"
            [errorCorrectionLevel]="correctionLevel"
            [value]="valueQR"
            alt="Demo QR Code"
            cssClass="qr"
            [width]="135">
          </ngx-qrcode>
        </div>
      </div>
      <div class="information-autoriza">
        <hr>
        <div class="Aut">Autoriza: </div>
      </div>
    </div>
  </div>

  <!-- VERTICAL PERSONAL -->
  <div class="vertical" *ngIf="position === 'vertical' && itemSelected && !isVehicle">
      <div class="first">
          <div class="title">{{itemSelected.EmployerName}}</div>
          <img src="{{s3Bucket+itemSelected.Photo}}" alt="">
          <div class="information">
              <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Name}} {{itemSelected.LastName}}</div>
              <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Position}}</div>
              <div class="field" style="text-align: center; font-weight: 700;">{{'ID'}}: {{itemSelected.DocumentNumber}}</div>
              <div class="field" style="text-align: center; font-weight: 700;">{{'RH'}}: {{itemSelected.RH}}</div>
          </div>
          <div class="information">
              <div class="information-data">
                  <div class="field">EPS: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameEPS}}</label></div>
                  <div class="field">ARL: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameARL}}</label></div>
              </div>
          </div>
      </div>
      <div class="second">
          <div class="content-vertical">
              <div class="content-qr">
                  <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
                  <ngx-qrcode
                      *ngIf="valueQR !== ''"
                      [elementType]="elementType"
                      [errorCorrectionLevel]="correctionLevel"
                      [value]="valueQR"
                      alt="Demo QR Code"
                      cssClass="qr"
                      style="margin-top: -150px;"
                      [width]="135">
                  </ngx-qrcode>
              </div>
            <div>
              <hr style="margin-left: 5px; margin-right: 6px;">
              <div class="field" style="margin-top: 5px; margin-left: 5px">Autoriza: </div>
            </div>
              <div class="terms" style="margin-top: 15px;">
                  Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
              </div>
          </div>
      </div>
  </div>

  <!-- VERTICAL VEHICLE IMPRIMIR -->
  <div class="vertical-vehicle" *ngIf="position === 'vertical' && itemSelected && isVehicle">
    <div class="first-vertical-vehicle">
      <div class="title-vertical-vehicle">{{itemSelected.EmployerName}}</div>
      <div class="photo-wrapper"><img src="{{getImgVehicle(itemSelected.Photo)}}" alt=""></div>
      <div class="information-vertical-vehicle">
        <div class="field-vehicle-vertical doc-type">
          <span class="owner-label">Tipo de documento:</span>
          <span class="doc-type-value-row" [class.stacked]="itemSelected?.DocumentType === 'REGISTRO_MAQUINARIA'">
            <span class="owner-value">{{ getDocumentTypeLabel(itemSelected?.DocumentType) }}</span>
            <span class="owner-value">{{ itemSelected.DocumentNumber }}</span>
          </span>
        </div>
        <div class="field-vehicle-vertical" *ngIf="itemSelected?.DocumentType !== 'REGISTRO_MAQUINARIA'">{{ getVehicleType(itemSelected?.VehicleTypeId) }}</div>
        <div class="field-vehicle-vertical owner">
          <span class="owner-label">Propietario:</span>
          <span class="owner-value">{{ (itemSelected?.OwnerName || '—') | uppercase }}</span>
        </div>
      </div>
    </div>
    <div class="second-vertical-vehicle">
      <div class="content-qr-generar-vehicle" style="margin-top: 21px;">
        <div class="qr-vehicle" *ngIf="valueQR === ''">Espacio para QR</div>
        <ngx-qrcode
          *ngIf="valueQR !== ''"
          [elementType]="elementType"
          [errorCorrectionLevel]="correctionLevel"
          [value]="valueQR"
          alt="Demo QR Code"
          cssClass="qr-vehicle"
          style="margin-top: -13px;"
          [width]="135">
        </ngx-qrcode>
      </div>
      <div class="content-vertical-generarVehicle ">
        <div>
          <hr style="margin-left: 5px; margin-right: 6px; margin-top: -20px">
          <div class="field-vehicle-vertical" style="margin-top: 5px; margin-left: 5px">Autoriza: </div>
        </div>
        <div class="terms-vehicle" style="margin-top: 13px;">
          Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
        </div>
      </div>
    </div>
  </div>

  <div class="nota-qr" *ngIf="print && data.print !==  'IMPRIMIR'">El código QR se genera automaticamente al imprimir el carnet</div>
  <div class="actions-dialog" *ngIf="print" style="margin-top: 3px;">
      <button mat-button class="btn-cancelar" [mat-dialog-close]="data" >CANCELAR</button>&nbsp;&nbsp;
      <button mat-button class="btn-generar" (click)="rePrintCarnet()">IMPRIMIR</button>
  </div>

</div>

<div class="content-print" *ngIf="data.print === 'GENERAR'">
  <div class="close" style="text-align: right; width: 100%; cursor: pointer;" *ngIf="!print">
    <h4 (click)="onNoClick()"><mat-icon>close</mat-icon></h4>
  </div>
  <div class="actions-dialog" style="margin-bottom: 3px;" *ngIf="print">
    <mat-radio-group  [(ngModel)]="position" style="margin-left: 35px;">
      <mat-radio-button color="warn" class="btn-cancelar" style="font-weight: bold; font-size: 16px;" value="horizontal"  (click)="position = 'horizontal'">HORIZONTAL</mat-radio-button>
      <mat-radio-button color="warn" class="btn-cancelar" style="font-weight: bold; font-size: 16px;" value="vertical" (click)="position = 'vertical'">VERTICAL</mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- HORIZONTAL PERSONAL GENERAR -->
  <div class="horizontal" *ngIf="position === 'horizontal' && itemSelected && !isVehicle">
    <div class="first">
      <div class="title">{{itemSelected.EmployerName}}</div>
      <div class="content-horizontal">
        <img src="{{s3Bucket+itemSelected.Photo}}" alt="">
        <div class="information">
          <div class="field">Nombre:</div>
          <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Name}}</div>
          <div class="field">Apellido:</div>
          <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.LastName}}</div>
          <div class="field">Cargo:</div>
          <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Position}}</div>
          <div class="field" style="text-align: center; font-weight: 700;">{{'ID'}}: {{itemSelected.DocumentNumber}}</div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="terms">
        Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
      </div>
      <div class="content-horizontal">
        <div class="information">
          <div class="information-data">
            <div class="filed">EPS: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameEPS}}</label></div>
            <div class="filed">ARL: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameARL}}</label></div>
            <div class="filed">RH: <label style="text-align: center; font-weight: 700;">{{itemSelected.RH}}</label></div>
          </div>
        </div>
        <div class="content-qr">
          <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
          <ngx-qrcode
            *ngIf="valueQR !== ''"
            [elementType]="elementType"
            [errorCorrectionLevel]="correctionLevel"
            [value]="valueQR"
            alt="Demo QR Code"
            cssClass="qr"
            [width]="135">
          </ngx-qrcode>
        </div>
      </div>
      <div class="information-autoriza">
        <hr>
        <div class="Aut">Autoriza: </div>
      </div>
    </div>
  </div>

  <!-- HORIZONTAL VEHICLE GENERAR -->
  <div class="horizontal" *ngIf="position === 'horizontal' && itemSelected && isVehicle">
    <div class="first">
      <div class="title">{{itemSelected.EmployerName}}</div>
      <div class="content-horizontal">
        <img src="{{getImgVehicle(itemSelected.Photo)}}" alt="">
        <div class="information-vehicle-horizontal">
          <div class="field-vehicle-horizontal doc-type">
            <span class="owner-label-horizontal">Tipo de documento:</span>
            <span class="doc-type-value-row" [class.stacked]="itemSelected?.DocumentType === 'REGISTRO_MAQUINARIA'">
              <span class="owner-value-horizontal">{{ getDocumentTypeLabel(itemSelected?.DocumentType) }}</span>
              <span class="owner-value-horizontal">{{ itemSelected.Name }}</span>
            </span>
          </div>
          <div class="field-vehicle-horizontal" *ngIf="itemSelected?.DocumentType !== 'REGISTRO_MAQUINARIA'">{{ getVehicleType(itemSelected?.VehicleTypeId) }}</div>
          <div class="field-vehicle-horizontal owner">
            <span class="owner-label-horizontal">Propietario:</span>
            <span class="owner-value-horizontal">{{ (itemSelected?.OwnerName || '—') | uppercase }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="terms">
        Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
      </div>
      <div class="content-horizontal">
        <div class="information">
          <div class="information-data">

          </div>
        </div>
        <div class="content-qr">
          <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
          <ngx-qrcode
            *ngIf="valueQR !== ''"
            [elementType]="elementType"
            [errorCorrectionLevel]="correctionLevel"
            [value]="valueQR"
            alt="Demo QR Code"
            cssClass="qr"
            [width]="135">
          </ngx-qrcode>
        </div>
      </div>
      <div class="information-autoriza">
        <hr>
        <div class="Aut">Autoriza: </div>
      </div>
    </div>
  </div>


  <!-- VERTICAL PERSONAL GENERAR -->
  <div class="vertical" *ngIf="position === 'vertical' && itemSelected && !isVehicle">
    <div class="first">
      <div class="title">{{itemSelected.EmployerName}}</div>
      <img src="{{s3Bucket+itemSelected.Photo}}" alt="">
      <div class="information">
        <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Name}} {{itemSelected.LastName}}</div>
        <div class="field" style="text-align: center; font-weight: 700;">{{itemSelected.Position}}</div>
        <div class="field" style="text-align: center; font-weight: 700;">{{'ID'}}: {{itemSelected.DocumentNumber}}</div>
        <div class="field" style="text-align: center; font-weight: 700;">{{'RH'}}: {{itemSelected.RH}}</div>
      </div>
      <div class="information">
        <div class="information-data">
          <div class="field">EPS: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameEPS}}</label></div>
          <div class="field">ARL: <label style="text-align: center; font-weight: 700;">{{itemSelected.NameARL}}</label></div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="content-qr-generar" style="margin-top: 20px;">
        <div class="qr" *ngIf="valueQR === ''">Espacio para QR</div>
        <ngx-qrcode
          *ngIf="valueQR !== ''"
          [elementType]="elementType"
          [errorCorrectionLevel]="correctionLevel"
          [value]="valueQR"
          alt="Demo QR Code"
          cssClass="qr"
          style="margin-top: -150px;"
          [width]="135">
        </ngx-qrcode>
      </div>
      <div class="content-vertical-generar ">
        <div>
          <hr style="margin-left: 5px; margin-right: 6px; margin-top: -20px">
          <div class="field" style="margin-top: 5px; margin-left: 5px">Autoriza: </div>
        </div>
        <div class="terms" style="margin-top: 13px;">
          Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
        </div>
      </div>
    </div>
  </div>

  <!-- VERTICAL VEHICLE GENERAR -->
  <div class="vertical-vehicle" *ngIf="position === 'vertical' && itemSelected && isVehicle">
    <div class="first-vertical-vehicle">
      <div class="title-vertical-vehicle">{{itemSelected.EmployerName}}</div>
      <div class="photo-wrapper"><img src="{{getImgVehicle(itemSelected.Photo)}}" alt=""></div>
      <div class="information-vertical-vehicle">
        <div class="field-vehicle-vertical doc-type">
          <span class="owner-label">Tipo de documento:</span>
          <span class="doc-type-value-row" [class.stacked]="itemSelected?.DocumentType === 'REGISTRO_MAQUINARIA'">
            <span class="owner-value">{{ getDocumentTypeLabel(itemSelected?.DocumentType) }}</span>
            <span class="owner-value">{{ itemSelected.DocumentNumber }}</span>
          </span>
        </div>
        <div class="field-vehicle-vertical" *ngIf="itemSelected?.DocumentType !== 'REGISTRO_MAQUINARIA'">{{ getVehicleType(itemSelected?.VehicleTypeId) }}</div>
        <div class="field-vehicle-vertical owner">
          <span class="owner-label">Propietario:</span>
          <span class="owner-value">{{ (itemSelected?.OwnerName || '—') | uppercase }}</span>
        </div>
      </div>
    </div>
    <div class="second-vertical-vehicle">
      <div class="content-qr-generar-vehicle" style="margin-top: 21px;">
        <div class="qr-vehicle" *ngIf="valueQR === ''">Espacio para QR</div>
        <ngx-qrcode
          *ngIf="valueQR !== ''"
          [elementType]="elementType"
          [errorCorrectionLevel]="correctionLevel"
          [value]="valueQR"
          alt="Demo QR Code"
          cssClass="qr-vehicle"
          style="margin-top: -13px;"
          [width]="135">
        </ngx-qrcode>
      </div>
      <div class="content-vertical-generarVehicle ">
        <div>
          <hr style="margin-left: 5px; margin-right: 6px; margin-top: -20px">
          <div class="field-vehicle-vertical" style="margin-top: 5px; margin-left: 5px">Autoriza: </div>
        </div>
        <div class="terms-vehicle" style="margin-top: 13px;">
          Esta autorización de ingreso es de uso obligatorio y debe portarse en un lugar visible para poder ingresar al área restringida. En cualquier momento se podrá solicitar y en caso de no portarlo será retirado inmediatamente de las instalaciones
        </div>
      </div>
    </div>
  </div>

  <div class="nota-qr">El código QR se genera automaticamente al imprimir el carnet</div>
  <div class="actions-dialog" *ngIf="print" style="margin-top: 3px;">
    <button mat-button class="btn-cancelar" [mat-dialog-close]="data" >CANCELAR</button>&nbsp;&nbsp;
    <button mat-button class="btn-generar" (click)="rePrintCarnet()">IMPRIMIR</button>
  </div>

</div>
